import func from "@/funcs";

export function uniformNumber(e, invalidMessage) {
  const el = e.target;
  const result = func.regExp.uniformNumber(el.value);
  func.validateResult.checkEl(el, result, invalidMessage);
}
